import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { SezioneParcelleGiudiziali } from '../../../models/sezioni/sezione-parcelle-giudiziali';
import { ParcelleGiudizialiAddComponent } from './parcelle-giudiziali-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parcella-giudiziale-mod-add]',
  templateUrl: 'parcella-giudiziale-mod-add.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParcellaGiudizialeModAdd {
  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali> = new EventEmitter<SezioneParcelleGiudiziali>();
  @ViewChild('formParcellaGiudizialeAdd') formParcellaGiudiziale: ParcelleGiudizialiAddComponent;


  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(idSezione: string,
              idFascicolo: string,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlInsert: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    if(this.isPrd) {
      this.formParcellaGiudiziale.inizializza(idSezione,
                                            idFascicolo,
                                            idSezioneLegali,
                                            idSezioneEconomica,
                                            urlInsert,
                                            urlReadSezioneLegali,
                                            urlReadSezioneEconomica,
                                            urlGetScaglioni,
                                            tipoFascicolo,
                                            tipoPratica);
    }
    openModal('modaladdParcellaGiudiziale');
  }

  createForm() {
    this.formParcellaGiudiziale.createForm();
  }

  manageModal(sezioneParcelleGiudiziali: SezioneParcelleGiudiziali) {
      closeModal('modaladdParcellaGiudiziale');
      this.onReturn.emit(sezioneParcelleGiudiziali);
  }
}
